import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'clu-confirm-dialog',
    templateUrl: './clu-confirm-dialog.component.html',
})
export class CluConfirmDialogComponent implements OnInit {
    title: string;
    message: string;
    confirmText : string | undefined = undefined;
    confirmTextInput : string = '';
    constructor(
        public dialogRef: MatDialogRef<CluConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private ngZone: NgZone
    ) {
        this.title = data.title;
        this.message = data.message;
        this.confirmText = data.confirmText;
    }

    ngOnInit() {
        this.dialogRef.keydownEvents().subscribe(event => { if (event.key === "Escape") { this.onDismiss(); } });
    }

    onConfirm(): void {
        this.ngZone.run(() => {
            this.dialogRef.close(true);
        });
    }
    
    onDismiss(): void {
        this.ngZone.run(() => {
            this.dialogRef.close(false);
        });
    }
}